/**
 * @fileoverview Prompt template for world-element-detailer-v3.
 *
 * Enriches detected world elements with descriptions scaled by classification.
 */

export const prompt = `
You are an expert world-building analyst. You will be given a list of detected world-building elements and the source text they were found in.

## TASK
For each detected element, write an initialDescription based on what the source text reveals about it. Match the depth to the element's classification:

- **critical**: 3-5 sentences. Cover what it is, its role in the plot, key attributes, and why it matters. Reference specific details from the text.
- **major**: 2-3 sentences. Cover what it is, its significance, and notable attributes.
- **minor**: 1 sentence. Capture what it is and its basic role.

## IMPORTANT
- Base descriptions ONLY on what the text reveals. Do not invent details.
- Preserve the exact name, type, element (subtype), and classification from the input. Do NOT change the element subtype.
- The **element** field must always be a specific subtype (e.g., "item", "artifact", "location"), NEVER a parent type name (e.g., "object", "place", "event").
- Process ALL elements in the list — do not skip any.

## LORE CONTEXT
<<<loreContext>>>

## DETECTED ELEMENTS
{{#if detectedElements}}
{{#each detectedElements}}
- **{{this.name}}** ({{this.type}}/{{this.element}}, {{this.classification}}): {{this.briefNote}}
{{/each}}
{{else}}
No elements to enrich.
{{/if}}

## SOURCE TEXT
{{{textInput}}}

## OUTPUT
For each element, return: name, type, element (subtype), classification, and initialDescription at the depth specified above.
`;
